<template>
  <div class="delivery-supplement">
    <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
      <gj-warehouse-select
          v-model="filter.warehouseIds"
          multiple
          :self="false"
          placeholder="仓库"
          width="180px"
      ></gj-warehouse-select>
      <gj-select-date-picker
          class="main-gj-select-date-picker"
          type="daterange"
          :width="['100px']"
          v-model="filter.date"
          :options="options.date"
      ></gj-select-date-picker>
      <gj-select-input
        v-model="filter.keyword"
        :options="options.keyword"
        :width="['100px', '150px']"
      ></gj-select-input>
    </app-filter-group>
    <div class="import-batch">
      <div>
        <!-- <gj-button type="primary" @click="importShipment">导入</gj-button> -->
        <gj-button type="primary" @click="addShippingInformation">添加</gj-button>
        <gj-button :disabled="noSelect" @click="formItemsChange('delectSelected')">删除</gj-button>
      </div>
      <gj-button @click="viewLog({id: null})">操作日志</gj-button>
    </div>
    <gj-alert style="padding: 12px 0;" type="warning" :title="titleMsg" show-icon></gj-alert>
    <el-form ref="form" :model="form" class="form-content">
      <gj-table
        ref="gjTable"
        size="has-picture"
        name="flag"
        :index="false"
        :data="form.items"
        :columns="columns"
        :loading="loading"
        selection
        :pagination="pagination"
        :default-sort="defaultSort"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:purchaseCost="{ row, index }">
          <template v-if="row.purchaseCostEdit">
            <el-form-item
              :prop="`items.${index}.purchaseCost`"
              :rules="[
                { required: true, message: '请输入采购成本', trigger: ['blur', 'change']},
                $gjReRule(RE.num(4), '最多四位小数的正数'),
              ]">
              <gj-input maxlength="10" v-model="row.purchaseCost" width="96%" @change="formItemsChange('change', row)">
                <template #prepend>￥</template>
              </gj-input>
            </el-form-item>
          </template>
          <span v-else max-width="90%">￥{{ row.purchaseCost }}</span>
          <div v-if="!row.purchaseCostEdit" class="gj-pointer gj-ml5"
            :class="{ 'gj-cell-display-switch': tableCellEdit || !row.purchaseCostEdit }" @click="row.purchaseCostEdit = true">
            <i class="el-icon-edit"></i>
          </div>
        </template>
        <template v-slot:arrivalCost="{ row, index }">
          <template v-if="row.arrivalCostEdit">
            <el-form-item
              :prop="`items.${index}.arrivalCost`"
              :rules="[
                { required: true, message: '请输入到库成本', trigger: ['blur', 'change'] },
                $gjReRule(RE.num(4), '最多四位小数的正数'),
              ]">
              <gj-input maxlength="8" v-model="row.arrivalCost" width="96%" @change="formItemsChange('change', row)">
                <template #prepend>￥</template>
              </gj-input>
            </el-form-item>
          </template>
          <span v-else max-width="90%">￥{{ row.arrivalCost }}</span>
          <div v-if="!row.arrivalCostEdit" class="gj-pointer gj-ml5"
            :class="{ 'gj-cell-display-switch': tableCellEdit || !row.arrivalCostEdit }" @click="row.arrivalCostEdit = true">
            <i class="el-icon-edit"></i>
          </div>
        </template>
        <!--操作  -->
        <template v-slot:op="{ row }">
          <gj-button type="text" @click="viewLog(row)">日志</gj-button>
          <gj-button type="text" @click="formItemsChange('delete', row)">删除</gj-button>
        </template>
      </gj-table>
    </el-form>
  </div>
</template>

<script>
import ImportShipment from "./ImportShipment.vue";
import AddShippingInformation from "./add-shipping-information.vue";
import { queryMixin, selectionMixin, formRuleMixin } from "@/minxins";
import { isMeaningful } from "@/utils/common";
import { convertToDate } from "@/utils/date.util"
import { storageCostBatchPageShipSupplement, storageCostBatchDeleteShipSupplement, storageCostBatchUpdateShipSupplement, supplementRecalculate} from "@/api/finance";

export default {
  name: "delivery-supplement",
  mixins: [ queryMixin, selectionMixin, formRuleMixin ],
  inject: ["getPublicData", "setPublicData"],
  data() {
    return {
      loading: false,
      titleMsg: "如货件未关联发货单可通过发货补录进行统一成本维护，当线下一个货件对应多个发货单，则可以用发货补录将已接收库存数量拆分，分别维护成本。现系统仅支持对未关联发货单、closed状态的货件进行发货补录。发货补录后，系统将在凌晨对扣减、利润统计与利润报表数据进行数据更新。",
      defaultSort: {prop: 'updateTime,msku,shipDate', order: 'descending,ascending,descending'},
      filter: {
        warehouseIds: null,
        date: {
          key: '1',
          value: [],
        },
        keyword: {
          key: "shipmentId",
          value: "",
        },
      },
      options: {
        keyword: [
          {id: "shipmentId", text: "货件号"},
          {id: "msku", text: "MSKU"},
          {id: "updateUserName", text: "更新人"},
        ],
        date: [
          {id: "1", text: "发货日期"},
          {id: "2", text: "更新日期"},
        ]
      },
      columns: [
        { id: 'warehouseName', fixed: "left", header: '仓库', field: 'warehouseName', minWidth: '120px' },
        { id: 'batchNumber', header: '批次号', field: 'batchNumber', minWidth: '135px' },
        { id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px' },
        { id: 'msku', header: 'MSKU', field: 'msku', minWidth: '170px' },
        { id: 'shipmentId', header: '货件号', field: 'shipmentId', minWidth: '135px' },
        { id: 'quantityShipped', header: '申报量', field: 'quantityShipped', minWidth: '100px' },
        { id: 'quantityReceived', header: '收货量', field: 'quantityReceived', minWidth: '100px' },
        { id: 'shipDate', header: '发货日期(北京时区)', field: 'shipDate', minWidth: '150px' },
        { id: 'shipQuantity', header: '补发数量', field: 'shipQuantity', minWidth: '100px' },
        { id: 'purchaseCost', header: '单个采购成本', field: 'slot:purchaseCost', minWidth: '150px' },
        { id: 'arrivalCost', header: '单个到库成本', field: 'slot:arrivalCost', minWidth: '150px' },
        { id: 'updateUserName', header: '更新人', field: 'updateUserName', minWidth: '80px' },
        { id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '155px' },
        { id: 'op', header: '操作', field: 'slot:op', minWidth: '90px', fixed: "right" },
      ],
      form: {
        items: []
      },
    };
  },
  created() {
    this.sort.prop = 'updateTime,msku,shipDate';
  },
  destroyed() {
    this.supplementRecalculate()
  },
  computed: {
    publicData() {
      return this.getPublicData()
    }
  },
  methods: {
    // 初始化
    $gjQueryInitParams() {
      return {
        filter: {
          warehouseIds: null,
          date: {
            key: '1',
            value: [],
          },
          keyword: {
            key: "shipmentId",
            value: "",
          },
        }
      }
    },
    // 搜索
    $gjQuery() {
      // 构造查询参数
      const params = {
        model: {
          warehouseIds: this.filter.warehouseIds,
        },
        ...this.queryPagination,
        ...this.querySort
      };
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      if (this.filter.date.value && this.filter.date.value.length !== 0) {
        if (this.filter.date.key === '1') {
          params.model.startShipDate = convertToDate(this.filter.date.value[0])
          params.model.endShipDate = convertToDate(this.filter.date.value[1])
        }else {
          params.model.startUpdateTime = convertToDate(this.filter.date.value[0])
          params.model.endUpdateTime = convertToDate(this.filter.date.value[1])
        }
      }
      this.globalParams = params;
      this.storageCostBatchPage(params)
    },
    async supplementRecalculate() {
      await supplementRecalculate()
    },
    // 查询list数据
    async storageCostBatchPage(params) {
      this.loading = true
      try {
        let { data } = await storageCostBatchPageShipSupplement(params)
        this.pagination = this.getPagination(data);
        let list = data.records || []
        list.forEach(item => {
          item.shipDateEdit = false
          item.shipQuantityEdit = false
          item.purchaseCostEdit = false
          item.arrivalCostEdit = false
        })
        this.formItemsChange('replace', list)
      } finally {
        this.loading = false
      }
    },
    // 表格数据更新
    formItemsChange(type, rows) {
      const opt = {
        replace: () => {
          this.form.items = [...rows]
        },
        change: () => {
          this.$refs.form.validate((valid) => {
            if(valid) {
              this.changeShipment(rows)
            }
          });
        },
        delete:() => {
          this.delShipment([rows.id])
        },
        delectSelected:() => {
          if (!this.selectedRows || this.selectedRows.length === 0) return false
          let row = this.selectedRows.map(e => e.id)
          this.delShipment(row)
        },
      }
      opt[type]()
    },
    // 添加发货计划
    addShippingInformation() {
      this.$gjCreate(AddShippingInformation, {
        props: {},
        on: {
          confirm: (rows) => {
            this.setPublicData('state', 'supplement-record')
            this.setPublicData('selectList', rows)
          },
        },
      });
    },
    // 删除
    delShipment(idList) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '删除确认',
          content: `<div>请确认是否删除？<div>
                    <div class="color666 size12 gj-mt12">删除影响：补录批次的数量及成本、扣减纪录、利润统计及利润报表，确认删除系统将在凌晨重算扣减及利润。</div>`
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: async () => {
            modal.confirmLoading = true;
            this.loading = true
            try {
              await storageCostBatchDeleteShipSupplement({ idList })
              this.$gjMessage.success("删除成功")
              this.$gjNoticeQuery()
            } finally {
              modal.$gjDestroy()
              this.loading = false
            }
          }
        }
      });
    },
    // 修改
    async changeShipment(row) {
      let params = {
        arrivalCost: this._.round(row.arrivalCost, 4),
        id: row.id,
        purchaseCost: this._.round(row.purchaseCost, 4),
        recalculate: true,
        shipDate: convertToDate(row.shipDate),
        shipQuantity: row.shipQuantity,
      }
      if (!row.arrivalCost || !row.purchaseCost || !row.shipQuantity || !row.shipDate) {
        return
      }
      this.loading = true
      try {
        await storageCostBatchUpdateShipSupplement(params)
        this.$gjMessage.success("修改成功")
        this.$gjNoticeQuery()
      } finally {
        this.loading = false
      }
    },
    // 导入发货计划
    importShipment() {
      this.$gjCreate(ImportShipment, {
        props: {},
        on: {
          importSuccess: (data) => {
            this.$gjNoticeQuery();
          },
          importPartSuccess: (data) => {
            this.$gjNoticeQuery();
          },
        },
      });
    },
    // 取消
    cancel() {
      this.$emit("cancel")
    },
    // 操作日志
    viewLog(row) {
      this.$gjCreate('gj-log-modal', {
        props: {
          url: '/supply/storageCostBatch/get/supplement/log/page',
          opTypeOption: [
            {id: 'save', text: '新增'},
            {id: 'update', text: '更新'},
            {id: 'delete', text: '删除'},
          ],
          params: {
            model: row.id
          }
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.delivery-supplement {
  padding-top: 12px;
}
.import-batch {
  padding: 12px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
// /deep/.el-alert--warning {
//   margin: 12px 0;
//   padding: 12px 20px;
//   font-size: 12px;
//   background: #EDF7FF;
//   border-radius: 2px;
//   border: 1px solid #9CCCFF;
//   color: #333333;
//   .el-alert__icon.el-icon-warning {
//     color: #1F6EEF;
//   }
// }
/deep/.form-content {
  .vxe-table--body {
    .vxe-body--row {
      .vxe-body--column {
        height: 54px !important;
        .el-form-item {
          margin: 8px 0 10px;
          position: relative;
        }
        .el-form-item__error {
          position: absolute;
          top: auto;
          bottom: -13px;
          left: 0;
          white-space: initial;
        }
      }
    }
  }
}

.opt {
  padding-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
